<template>
  <div class="w-100 mt-5">
    <!-- MODAL GALLERY -->
    <div
      class="modal fade"
      id="modalGalery"
      tabindex="-1"
      aria-labelledby="modalGaleryLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title fsize-14" id="modalGaleryLabel">
              Product Images
            </p>
          </div>
          <div class="modal-body">
            <div class="image-container">
              <img
                @click="handleSelectImage(image)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
                :src="image"
                class="img-display rounded"
                alt=""
                v-for="(image, index) in image_urls"
                :key="image"
                @error="imageLoadError(index)"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-lg btn-outline-danger fw-bold"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL IMAGE -->
    <div
      class="modal fade"
      id="modalImage"
      tabindex="-1"
      aria-labelledby="modalImageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="image-container">
              <Image :src="selectedImage" className="rounded image-detail" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-lg btn-outline-danger fw-bold"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Product Sold" :cardData="dataProduct[0]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Product View" :cardData="dataProduct[1]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Product Favorited" :cardData="dataProduct[2]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Product Status" :cardData="dataProduct[3]" />
      </div>
    </div>
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-lg-6 me-5">
            <p class="fw-bold">Product Info</p>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Product ID</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control fw-bold"
                  v-model="product_sku"
                  disabled
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Product Name </label>
              <div class="col-sm-9">
                <CustomInput
                  type="text"
                  placeholder="Product Name"
                  :inputClass="'fw-bold'"
                  :value="name"
                  @onChange="(value) => (name = value)"
                  maxlength="255"
                  :error="errors.name"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Category Product </label>
              <div class="col-sm-9">
                <span
                  class="badge mt-1 fw-bold rounded"
                  style="
                    color: #5e50a1;
                    background-color: #f3f2f8;
                    font-size: 12px;
                  "
                  >{{ category_product }}</span
                >
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Category Promo </label>
              <div class="col-sm-9">
                <span
                  class="badge mt-1 me-2 fw-bold rounded"
                  style="
                    color: #5e50a1;
                    background-color: #f3f2f8;
                    font-size: 12px;
                  "
                  v-for="category in category_promo"
                  :key="category"
                >
                  {{ category.name }}
                </span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Product Description</label>
              <div class="col-sm-9">
                <CustomInput
                  :textarea="true"
                  placeholder="Product Description"
                  :value="description"
                  @onChange="(value) => (description = value)"
                  maxlength="3000"
                  :error="errors.description"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <p class="text-end fw-bold">
                Created Date :
                {{ filters.dateFull(created_date, { separator: false }) }}
              </p>
            </div>
          </div>
          <div class="col-lg-3">
            <p class="fw-bold">Product Images ({{ image_urls.length }})</p>
            <div class="row">
              <div class="d-flex col-md-10">
                <div class="me-3">
                  <img
                    @click="handleSelectImage(image_urls[0])"
                    data-bs-toggle="modal"
                    data-bs-target="#modalImage"
                    :src="image_urls[0]"
                    class="img-display rounded border border-0"
                    alt=""
                    @error="imageLoadError(0)"
                  />
                </div>
                <div class="me-3">
                  <img
                    v-if="image_urls[1]"
                    @click="handleSelectImage(image_urls[1])"
                    data-bs-toggle="modal"
                    data-bs-target="#modalImage"
                    :src="image_urls[1]"
                    class="img-display rounded border border-0"
                    alt=""
                    @error="imageLoadError(1)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="d-flex col-md-10 mt-3">
                <div class="me-3">
                  <img
                    v-if="image_urls[2]"
                    @click="handleSelectImage(image_urls[2])"
                    data-bs-toggle="modal"
                    data-bs-target="#modalImage"
                    :src="image_urls[2]"
                    class="img-display rounded border border-0"
                    alt=""
                    @error="imageLoadError(2)"
                  />
                </div>
                <div
                  class="me-3 position-relative"
                  :data-bs-toggle="image_urls.length >= 4 ? 'modal' : ''"
                  :data-bs-target="image_urls.length >= 4 ? '#modalGalery' : ''"
                >
                  <template v-if="image_urls[3]">
                    <div class="overlay rounded">
                      <span>{{ image_urls.length - 3 }} foto lainnya</span>
                    </div>
                    <img
                      :src="image_urls[3]"
                      class="img-display rounded border border-0"
                      alt=""
                      @error="imageLoadError(3)"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-lg-12 me-5">
            <p class="fw-bold">Product Detail</p>
            <div class="mb-3 row">
              <label class="col-sm-2 col-form-label">Product Dimension</label>
              <div class="col-sm-5">
                <div class="row">
                  <div class="col-sm-4 d-flex">
                    <label class="col-sm-5 col-form-label">Length</label>
                    <div class="col-md-7">
                      <CustomInput
                        type="number"
                        placeholder="0cm"
                        :value="length"
                        @onChange="(value) => (length = value)"
                        suffix="cm"
                        :max="50"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4 d-flex">
                    <label class="col-sm-5 col-form-label">Width</label>
                    <div class="col-sm-7">
                      <CustomInput
                        type="number"
                        placeholder="0cm"
                        :value="width"
                        @onChange="(value) => (width = value)"
                        suffix="cm"
                        :max="50"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4 d-flex">
                    <label class="col-sm-5 col-form-label">Height</label>
                    <div class="col-sm-7">
                      <CustomInput
                        type="number"
                        placeholder="0cm"
                        :value="height"
                        @onChange="(value) => (height = value)"
                        suffix="cm"
                        :max="50"
                      />
                    </div>
                  </div>
                </div>
                <span v-if="errors.size" class="text-danger error-text">{{
                  errors.size
                }}</span>
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-2 col-form-label">Product Weight </label>
              <div class="col-sm-5">
                <CustomInput
                  type="number"
                  placeholder="0gr"
                  :value="weight"
                  @onChange="(value) => (weight = value)"
                  suffix="gr"
                  :max="5000"
                  :error="errors.weight"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-2 col-form-label">Current Stock</label>
              <div class="col-sm-5">
                <CustomInput
                  type="number"
                  placeholder="0"
                  :value="stock"
                  @onChange="(value) => (stock = value)"
                  :disabled="(isVariant && !isVariantEmpty) || !isVariantEmpty"
                  :max="1000"
                  :error="errors.stock"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label class="col-sm-2 col-form-label">Reserve Stock</label>
              <div class="col-sm-5">
                <CustomInput
                  type="number"
                  placeholder="0"
                  :value="reserve"
                  disabled
                  :error="errors.reserve"
                />
              </div>
            </div>
            <div
              class="mb-3 row"
              :hidden="(isVariant && !isVariantEmpty) || !isVariantEmpty"
            >
              <label class="col-sm-2 col-form-label">Price</label>
              <div class="col-sm-5">
                <CustomInput
                  type="number"
                  placeholder="Rp0"
                  :value="price_regular"
                  :isRupiah="true"
                  @onChange="(value) => (price_regular = value)"
                  :max="150000000"
                  :error="errors.price_regular"
                />
              </div>
            </div>

            <div
              class="mb-3 row"
              :hidden="(isVariant && !isVariantEmpty) || !isVariantEmpty"
            >
              <label class="col-sm-2 col-form-label">Discounted Price</label>
              <div class="col-sm-5">
                <CustomInput
                  type="number"
                  placeholder="Rp0"
                  :isRupiah="true"
                  :value="price_sale"
                  @onChange="(value) => (price_sale = value)"
                  :max="150000000"
                  :error="errors.price_sale"
                />
              </div>
            </div>
            <div
              class="mb-3 row"
              :hidden="(!isVariant && isVariantEmpty) || isVariantEmpty"
            >
              <label class="col-sm-2 col-form-label">Display Price</label>
              <div class="col-sm-5">
                <CustomInput
                  type="string"
                  disabled
                  :value="price_displayed"
                  :error="errors.price_displayed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-lg-12 me-5">
            <p class="fw-bold">Product Variant</p>
            <table class="table bg-white" style="border: #e6eaf5 !important">
              <thead>
                <tr>
                  <th
                    scope="col"
                    v-for="data in payload.header"
                    :key="data"
                    :class="data.class"
                  >
                    {{ data.label }}
                  </th>
                </tr>
              </thead>
              <tbody
                style="border-top: transparent"
                v-for="(data, index) in payload.value"
                :key="data"
              >
                <tr>
                  <td
                    v-for="compare in payload.header"
                    :class="compare.class"
                    :key="compare"
                  >
                    <template v-if="compare.type == 'image'">
                      <div
                        @click="
                          handleSelectImage(payload.value[index][compare.key])
                        "
                        :style="
                          payload.value[index][compare.key]
                            ? 'cursor:pointer;'
                            : ''
                        "
                        :data-bs-toggle="
                          payload.value[index][compare.key] ? 'modal' : ''
                        "
                        :data-bs-target="
                          payload.value[index][compare.key] ? '#modalImage' : ''
                        "
                      >
                        <Image
                          :src="payload.value[index][compare.key]"
                          :width="32"
                          :height="32"
                          className="rounded m-3"
                          :style="'object-fit:contain;background-color: #F3F2F8;'"
                        />
                      </div>
                    </template>
                    <div v-if="compare.type == 'text'">
                      <CustomInput
                        type="text"
                        :placeholder="
                          compare.key !== 'product_id'
                            ? 'e.g. Small, Medium, Large'
                            : ''
                        "
                        :value="payload.value[index][compare.key]"
                        @onChange="
                          (value) => (payload.value[index][compare.key] = value)
                        "
                        :disabled="compare.key == 'product_id'"
                        maxlength="32"
                        :lengthIndicator="compare.key !== 'product_id'"
                        :error="
                          errors['product_variant']?.[index]?.[compare.key]
                        "
                      />
                    </div>
                    <div v-else-if="compare.type == 'number'">
                      <CustomInput
                        type="number"
                        :placeholder="
                          compare.key !== 'stock_current' ? 'Rp0' : '0'
                        "
                        :isRupiah="compare.key !== 'stock_current'"
                        :value="payload.value[index][compare.key]"
                        @onChange="
                          (value) => (payload.value[index][compare.key] = value)
                        "
                        :max="
                          compare.key !== 'stock_current' ? 150000000 : 1000
                        "
                        :error="
                          errors['product_variant']?.[index]?.[compare.key]
                        "
                      />
                    </div>
                    <div v-else-if="compare.type == 'button'">
                      <button
                        v-if="!payload.value[index].reserve_stock"
                        class="btn"
                        @click="deleteRow(index)"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-trash"
                          class="text-danger fw-bold"
                        />
                      </button>
                      <button v-else class="btn disable">
                        <PopOver
                          :position="['left']"
                          :popoverStyle="{
                            backgroundColor: '#FFE9B9',
                            textAlign: 'left',
                            fontWeight: '300',
                            border: '2px solid #FFB003',
                          }"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-trash"
                            class="text-danger opacity-50"
                          />
                          <template v-slot:text>
                            <div class="d-flex" :style="{ gap: '8px' }">
                              <img
                                :style="{
                                  width: '10px',
                                  height: '10px',
                                  marginTop: '2px',
                                }"
                                src="@/assets/ic_info_yellow.png"
                                alt="icon-info"
                              />
                              <span
                                >Can't delete this variant, because
                                {{ payload.value[index].reserve_stock }} item{{
                                  payload.value[index].reserve_stock > 1
                                    ? "s are "
                                    : " "
                                }}
                                being ordered by the buyer</span
                              >
                            </div>
                          </template>
                        </PopOver>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center align-items-center">
              <button
                class="btn text-center rounded w-25 fw-bold p-3"
                style="color: #5e50a1; background-color: #f3f2f8"
                @click="addRows"
              >
                <font-awesome-icon icon="fa-solid fa-plus" /> Add Variant Name
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-start">
      <button
        type="button"
        class="btn btn-danger text-white shadow-sm rounded p-2 text-uppercase rounded my-3"
        :disabled="!isDataChanged"
        @click="updateProduct"
      >
        UPDATE PRODUCT
      </button>
    </div>
  </div>
</template>

<script>
import CardInfo from "@/components/CardInfo.vue";
import CustomInput from "@/components/CustomInput.vue";
import Image from "@/components/Image.vue";
import PopOver from "@/components/PopOver.vue";
import defaultImage from "@/assets/defaultImage.png";
import lodash from "lodash";

export default {
  components: {
    CardInfo,
    CustomInput,
    Image,
    PopOver,
  },
  created() {
    const listRoute = this.$route.path.split("/");
    this.review = this.$route.query.review;
    this.id = listRoute[listRoute.length - 1];
  },
  data() {
    return {
      isDataChanged: false,
      initialValue: {},
      isVariant: false,
      isVariantEmpty: false,
      errors: {},
      price_displayed: "",
      price_regular: 0,
      price_sale: 0,
      id: "",
      product_sku: "",
      name: "",
      description: "",
      created_date: "",
      product_status: "",
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      stock: 0,
      reserve: 0,
      category_product: "",
      category_promo: [],
      product_variant: [],
      product_remove_ids: [],
      image_urls: [defaultImage],
      selectedImage: "",
      dataProduct: [
        {
          value: 0,
          color: "red",
          url: "",
        },
        {
          value: 0,
          color: "green",
          url: "",
        },
        {
          value: 0,
          color: "green",
          url: "",
        },
        {
          value: 0,
          color: "green",
          url: "",
        },
      ],
      payload: {
        header: [
          {
            key: "image_url",
            label: "Image",
            class: "text-center",
            type: "image",
          },
          {
            key: "name",
            label: "Variant Name",
            class: "text-center",
            type: "text",
          },
          {
            key: "stock_current",
            label: "Stock",
            class: "text-center",
            type: "number",
          },
          {
            key: "price_regular",
            label: "Price",
            class: "text-center",
            type: "number",
          },
          {
            key: "price_sale",
            label: "Discounted Price",
            class: "text-center",
            type: "number",
          },
          {
            key: "product_id",
            label: "Variant ID",
            class: "text-center",
            type: "text",
          },
          {
            key: "action",
            label: "Actions",
            class: "text-center",
            type: "button",
          },
        ],
        value: [],
      },
      rows: 0,
      review: false,
    };
  },
  computed: {
    dataPayload() {
      return {
        id: this.id,
        name: this.name,
        sku: this.id,
        description: this.description,
        length: this.length,
        width: this.width,
        height: this.height,
        weight: this.weight,
        stock: this.stock,
        price_regular: this.price_regular,
        price_sale: this.price_sale,
        product_variant: this.payload.value,
        product_remove_ids: this.product_remove_ids,
        image_urls: this.image_urls.filter(
          (x) => x !== "/img/defaultImage.9942ca3c.png"
        ),
      };
    },
    queryStatusUrl() {
      if (this.product_status == "Published" && this.stock <= 0)
        return "LiveOutOfStock";
      if (this.product_status == "Published") return "LiveInStock";
      return this.product_status;
    },
    checkIsVariant() {
      return (this.isVariant && !this.isVariantEmpty) || !this.isVariantEmpty;
    },
  },
  watch: {
    dataPayload: {
      handler(value) {
        this.handleChange(value);
      },
      deep: true,
    },
  },
  methods: {
    handleSelectImage(src) {
      if (src) {
        this.selectedImage = src;
      }
    },
    imageLoadError(index) {
      console.log("IMAGE ERROR" + index);
      this.image_urls[index] = defaultImage;
    },
    setInitialValue(res) {
      let productVariants = res.product.is_variant
        ? res.product.product_variants.map((x) => {
            x.action = {
              delete: "enable",
            };
            /**
             * note, when save product variant (product not in discount) in Seller app,
             * discount price filled with product price, with this cond, if it equals,
             * set is as 0, for this case set as empty string for CustomInput
             */
            x.price_sale = x.price_sale === x.price_regular ? "" : x.price_sale;
            return x;
          })
        : [];

      let data = {};
      data.id = res.product.id;
      data.name = res.product.name;
      data.sku = res.product.id;
      data.description = res.product.description;
      data.length = res.product.size[0];
      data.width = res.product.size[1];
      data.height = res.product.size[2];
      data.weight = res.product.weight;
      data.stock = res.product.stock_current;
      data.price_regular = res.product.price_regular;
      data.price_sale =
        res.product.price_regular === res.product.price_sale
          ? ""
          : res.product.price_sale;

      // to diff the obj reference
      data.product_variant = JSON.parse(JSON.stringify(productVariants));
      data.product_remove_ids = [];

      res?.product?.image_urls?.forEach((img, i) => {
        if (data?.image_urls) {
          data.image_urls.push(this.filters.imageParse(img));
        } else {
          data.image_urls = [this.filters.imageParse(img)];
        }
      });

      this.initialValue = data;
    },
    handleChange: lodash.debounce(function (value) {
      let isChanged = false;
      // console.log({value, initialValue: this.initialValue})
      Object.keys(this.initialValue).forEach((key) => {
        if (typeof value[key] !== "object") {
          const isNumber = this.filters.isNumber(this.initialValue[key]);
          let options = { trim: true };
          if (isNumber) options = { number: true };
          // disable trim for price sale
          if (key == "price_sale") options.trim = false;
          if (
            !this.filters.isStringSame(
              value[key],
              this.initialValue[key],
              options
            )
          ) {
            isChanged = true;
          }
        } else {
          // handle deep nested changes product_variant
          if (key === "product_variant") {
            value[key].forEach((obj, i) => {
              Object.keys(obj).forEach((subKey) => {
                if (
                  typeof value[key][i][subKey] === "number" ||
                  typeof value[key][i][subKey] === "string"
                ) {
                  if (
                    !this.filters.isStringSame(
                      value[key][i][subKey],
                      this.initialValue?.[key]?.[i]?.[subKey]
                    )
                  ) {
                    isChanged = true;
                  }
                }
              });
            });
          }
          // handle remove actions, if current have value, count it as true
          if (key === "product_remove_ids" && value[key].length) {
            isChanged = true;
          }
        }
      });
      this.isDataChanged = isChanged;
    }, 500),
    async getData() {
      const url = this.review
        ? "product/getOneProductReview"
        : "product/getOneProduct";
      const response = await this.$store.dispatch(url, this.id);
      console.log(response);

      let productVariants = response.product.is_variant
        ? response.product.product_variants.map((x) => {
            x.action = {
              delete: "enable",
            };
            /**
             * note, when save product variant (product not in discount) in Seller app,
             * discount price filled with product price, with this cond, if it equal,
             * set is as 0, for this case set as empty string for CustomInput
             */
            x.price_sale = x.price_sale === x.price_regular ? "" : x.price_sale;
            return x;
          })
        : [];

      this.price_displayed = response.product.price_displayed;
      this.price_regular = response.product.price_regular;
      this.price_sale =
        response.product.price_regular === response.product.price_sale
          ? ""
          : response.product.price_sale;
      this.product_sku = response.product.id;
      this.name = response.product.name;
      this.description = response.product.description;
      this.length = response.product.size[0];
      this.width = response.product.size[1];
      this.height = response.product.size[2];
      this.weight = response.product.weight;
      this.stock = response.product.stock_current;
      this.reserve = response.product.reserve_stock;
      this.created_date = response.product.created_date;
      this.product_status = response?.product?.product_status;
      this.dataProduct[0].value = response?.product?.product_data?.sold || 0;
      this.dataProduct[1].value = response?.product?.product_data?.viewed || 0;
      this.dataProduct[2].value = response?.product?.product_data?.liked || 0;
      this.dataProduct[3].value = response?.product?.product_status || "-";

      if (response?.product?.product_status == "Published") {
        if (response?.product?.stock_current > 0) {
          this.dataProduct[3].value = "Live In Stock";
        } else {
          this.dataProduct[3].value = "Live Out Of Stock";
        }
      }

      this.category_product = `${
        response?.product?.category_product?.parent_category_name || "-"
      } / ${response.product?.category_product?.name || "-"}`;
      this.category_promo = response.category_promo_list
        ? response.category_promo_list
        : [];
      this.payload.value = productVariants;

      this.rows = this.payload.value.lengths - 1;

      response?.product?.image_urls?.forEach((img, i) => {
        this.image_urls[i] = this.filters.imageParse(img);
      });

      this.isVariant = response.product.is_variant;
      this.isVariantEmpty = !response.product.is_variant;
      this.setInitialValue(response);
    },
    handleValidation(data) {
      let errors = {};
      if (data.name.length < 5)
        errors.name = "Product name minimum 5 characters";
      if (!data.name) errors.name = "Product name cannot be empty";

      if (data.description.length < 64)
        errors.description = "Product description minimum 64 characters";
      if (!data.description)
        errors.description = "Product description cannot be empty";
      if (data.description.length > 3000)
        errors.description =
          "Product Description max length more than 3000 characters";
      if (data?.size?.some((x) => x < 0 || x > 50))
        errors.size = "Dimension range is 0cm ~ 50cm";
      if (data.weight < 0 || data.weight > 5000)
        errors.weight = "Weight range is 0gr ~ 5000gr";
      if (!this.checkIsVariant) {
        if (!data.stock && data.stock !== 0) {
          errors.stock = "Stock cannot be empty";
        }
        if (data.stock < 0 || data.stock > 1000)
          errors.stock = "Stock range is 0 ~ 1000";
        if (data.stock < this.reserve)
          errors.stock = "Stock can't be less than reserve stock";

        if (data.price_regular < 99)
          errors.price_regular = "Price minimum value is 99";
        if (!data.price_regular) errors.price_regular = "Price cannot be empty";

        if (data.price_sale && data.price_sale < 98)
          errors.price_sale = "Discounted price minimum value is 98";
        if (data.price_sale > data.price_regular)
          errors.price_sale =
            "Discounted price cannot be greater than product price";
      }

      /**
       * check if there is an atempt change product simple to product variant
       * but have a reserve stock value
       */

      if (!this.isVariant && !this.isVariantEmpty && this.reserve) {
        errors.reserve = `Can't change product to variant because reserved ${this.reserve} by buyer`;
      }

      if (
        typeof data?.product_variant === "object" &&
        data?.product_variant?.length
      ) {
        errors.product_variant = [];
        data.product_variant.forEach((variant) => {
          let variantErr = {};
          Object.keys(variant).forEach((key) => {
            if (key === "name") {
              if (!variant[key])
                variantErr.name = "Variant name cannot be empty";
            }
            if (key === "stock_current") {
              if (!variant[key] && variant[key] !== 0)
                variantErr.stock_current = "Stock cannot be empty";
              if (variant[key] < 0 || variant[key] > 1000)
                variantErr.stock_current = "Stock range is 0 ~ 1000";
              if (variant[key] < variant.reserve_stock)
                variantErr.stock_current = `Stock can't be less than reserve stock (${
                  variant.reserve_stock
                } item${variant.reserve_stock > 1 ? "s" : ""})`;
            }
            if (key === "price_regular") {
              if (variant[key] < 99)
                variantErr.price_regular = "Price minimum value is 99";
              if (!variant[key])
                variantErr.price_regular = "Price cannot be empty";
            }
            if (key === "price_sale") {
              if (variant[key] && variant[key] < 98)
                variantErr.price_sale = "Discounted price minimum value is 98";
              if (variant[key] > variant["price_regular"])
                variantErr.price_sale =
                  "Discounted price cannot be greater than product price";
            }
          });
          errors.product_variant.push(variantErr);
        });
        // if each one of them product variant have no error, remove it field
        if (errors.product_variant.every((x) => !Object.values(x).length))
          delete errors.product_variant;
      }

      console.log({ errors });

      if (Object.keys(errors).length) {
        this.errors = errors;
        return false;
      } else {
        this.errors = {};
      }
      return true;
    },
    async updateProduct() {
      try {
        let productVariant = this.payload.value.map((x) => {
          return {
            name: x.name,
            price_regular: x.price_regular,
            price_sale: x.price_sale == "" ? 0 : x.price_sale,
            product_id: x.product_id,
            stock_current: x.stock_current,
            reserve_stock: x?.reserve_stock || 0,
            image_url: x?.image_url || "",
          };
        });
        const length = this.length == "" ? 0 : parseInt(this.length);
        const width = this.width == "" ? 0 : parseInt(this.width);
        const height = this.height == "" ? 0 : parseInt(this.height);
        const weight = this.weight == "" ? 0 : parseInt(this.weight);
        let payload = {
          id: this.id,
          name: this.name,
          sku: this.id,
          price_regular: this.price_regular,
          price_sale:
            this.price_sale == "" ? this.price_regular : this.price_sale,
          description: this.description,
          length: length,
          width: width,
          height: height,
          weight: weight,
          stock: this.stock,
          size: [length, width, height],
          product_variant: productVariant,
          product_remove_ids: this.product_remove_ids,
        };

        if (!this.handleValidation(payload)) {
          // stop process if validation failed
          return;
        }

        if (this.checkIsVariant) {
          payload.price_regular = this.initialValue.price_regular;
          payload.price_sale =
            this.initialValue.price_sale == ""
              ? this.initialValue.price_regular
              : this.initialValue.price_sale;
        }
        if (!payload.stock) {
          payload.stock = 0;
        }
        await this.$store.dispatch("product/updateProduct", payload);

        setTimeout(() => {
          this.$router.push(
            "/products/all-product?status=" + this.queryStatusUrl
          );
        }, 500);
      } catch (err) {
        console.log(err);
      }
    },
    addRows() {
      this.isVariantEmpty = false;
      this.payload.value.push({
        new_row: true,
        product_id: "",
        name: "",
        price_regular: 0,
        price_sale: 0,
        disc_percentage: 0,
        stock_current: 0,
        sku: "",
      });
    },
    deleteRow(index) {
      if (this.rows > 1) {
        this.rows -= 1;
      }
      console.log(index);
      const productId = this.payload.value[index].product_id;
      this.payload.value.splice(index, 1);
      if (productId) {
        this.product_remove_ids.push(productId);
      }
      console.log(this.product_remove_ids);

      if (!this.payload.value.length) {
        this.isVariantEmpty = true;
        if (this.isVariant) this.stock = "";
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.image-detail {
  object-fit: contain;
  background-color: #f3f2f8;
  width: 100%;
  max-width: 480px;
  height: 480px;
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  background-color: rgba(65, 64, 66, 0.4);
  inset: 0;
  padding: 10px 15px;
  cursor: pointer;
  span {
    font-size: 12px;
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
}
.modal-content {
  padding: 2rem;
}
.modal-footer {
  justify-content: flex-start;
  border-top: none;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 2rem;
}
.img-display {
  cursor: pointer;
  object-fit: contain;
  min-width: 100px;
  min-height: 100px;
  width: 100px;
  height: 100px;
  background-color: #f3f2f8;
}
.error-border {
  border: 1px red solid !important;
}

td {
  vertical-align: middle;
}
.btn {
  &.disable {
    cursor: default;
    border: none;
  }
}
</style>
